import { useState } from 'react';
import { PaymentService } from '../services/payment/paymentService';
import { useVoteStore } from '../stores/voteStore';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from './useToast';

export const usePayment = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState<string | null>(null);
  const [reference, setReference] = useState<string | null>(null);
  const { showToast } = useToast();
  
  const { contestantId, selectedTier, phoneNumber, reset } = useVoteStore();
  const queryClient = useQueryClient();
  const paymentService = new PaymentService();

  const initializePayment = async () => {
    if (!contestantId || !selectedTier || !phoneNumber) {
      showToast('Informations de vote incomplètes', 'error');
      return;
    }

    setIsLoading(true);

    try {
      const response = await paymentService.initializeVotePayment({
        contestantId,
        amount: selectedTier.amount,
        phoneNumber,
        votes: selectedTier.votes
      });

      setPaymentUrl(response.paymentUrl);
      setReference(response.reference);
      showToast('Paiement initialisé avec succès', 'success');
    } catch (error) {
      showToast(
        error instanceof Error ? error.message : 'Erreur lors de l\'initialisation du paiement',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const verifyPayment = async () => {
    if (!reference) return;

    try {
      const verification = await paymentService.verifyPayment(reference);

      if (verification.status === 'completed') {
        showToast('Paiement confirmé ! Merci pour votre vote', 'success');
        queryClient.invalidateQueries(['contestants']);
        reset();
      } else if (verification.status === 'failed') {
        showToast('Le paiement a échoué. Veuillez réessayer', 'error');
      }

      return verification;
    } catch (error) {
      showToast('Erreur lors de la vérification du paiement', 'error');
    }
  };

  return {
    initializePayment,
    verifyPayment,
    isLoading,
    paymentUrl,
    reference
  };
};